<template>
  <div v-if="showView">
    <header class="header fixed-top">
      <nav class="navbar navbar-light bg-light">
        <div class="container navbarCont" style="padding: 0">
          <a class="navbar-brand">
            <img src="../assets/logo3.png" class="logo" />
          </a>
          <form class="form-inline searchbox" @submit.prevent="submit1">
            <input
              type="text"
              class="navInput"
              placeholder="请输入关键字"
              placeholder-class="ipt"
              v-model="INPUT"
            />
            <button class="navbtn" type="submit">
              <img src="../assets/search.png" class="searchico" />
              搜索
            </button>
          </form>
        </div>
      </nav>
      <nav
        class="navbar navbar-expand-lg navbar-light"
        :class="[scrollTop > 100 ? 'shadow' : '']"
        :style="{ background: backgroundColor }"
      >
        <div
          class="container navBox"
          style="display: flex; justify-content: flex-end"
        >
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarsExampleDefault"
            aria-controls="navbarsExampleDefault"
            aria-expanded="false"
            aria-label="Toggle navigation"
            @click="collapseNav"
          >
            <span class="navbar-toggler-icon">
              <img v-if="isCollapse" :src="bgimg1" />
              <img v-else :src="bgimg2" />
            </span>
          </button>

          <div
            class="collapse navbar-collapse"
            id="navbarsExampleDefault"
            style="justify-content: center"
          >
            <ul class="navbar-nav">
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/"
                  >首页</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/about"
                  >关于我们</router-link
                >
              </li>
              <li
                class="nav-item"
                :class="[scrollTop > 100 ? 'active2' : 'active']"
              >
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/product"
                  >产品中心</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/support"
                  >技术支持</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/news"
                  >新闻动态</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/contact"
                  >联系我们</router-link
                >
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :style="{ color: fontColor }"
                  to="/hire"
                  >人才招聘</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
    <div class="spacebox"></div>
    <main>
      <!-- 顶部图 -->
      <div class="pictureBox" v-if="picture">
        <img :src="picture.P_IMG" />
      </div>

      <!-- 产品中心 -->
      <div class="productCenter">
        <div class="left">
          <ul class="typeList">
            <li class="navTitle">产品中心</li>
            <li
              class="typeItem"
              :class="[currentIdx == index ? 'active' : '']"
              v-for="(item, index) in typeList"
              :key="index"
              @click="switchType(index, item.DB_TYPE_ID)"
            >
              <p>{{ item.T_NAME }}</p>
            </li>
          </ul>
        </div>
        <div
          class="right"
          :style="{ 'padding-bottom': sumPages > 1 ? '3rem' : '0' }"
        >
          <ul class="productList" v-if="prodList.length > 0">
            <li
              class="productItem"
              :style="{ 'border-color': item.active ? '#020E62' : '#ECECEC' }"
              v-for="(item, index) in prodList"
              :key="index"
              @click="openDetails(item.DB_PRODUCT_ID)"
              @mouseenter="mouseenter(index)"
              @mouseleave="mouseleave(index)"
            >
              <div :src="item.P_IMG" class="prodIco">
                <img :src="item.P_IMG" :class="[item.active ? 'expand' : '']" />
              </div>
              <div class="prod-name" :class="[item.active ? 'prod-name2' : '']">
                <span>{{ item.P_NAME }}</span>
              </div>
              <img
                src="../assets/add1.png"
                class="add"
                :style="{ display: item.active ? 'block' : 'none' }"
              />
            </li>
          </ul>
          <div class="searchResult" v-if="prodList.length == 0">
            暂无产品列表！
          </div>
          <div class="pagesBlock" v-if="sumPages > 1">
            <flPagination
              :totalPage="sumPages"
              :current="1"
              @on-change="handlePageChange"
            ></flPagination>
          </div>
        </div>
      </div>

      <!-- 提醒弹窗 -->
      <div class="modal-bg" v-if="isShow4">
        <div class="modal-container">
          <div class="modal-top">
            <p class="modal-title">信息</p>
            <img
              src="../assets/cancel.png"
              class="close"
              @click="hideModal()"
            />
          </div>

          <div class="modal-main">{{ message }}</div>
          <div class="modal-bottom">
            <p class="confirmBtn" @click="hideModal">确定</p>
          </div>
        </div>
      </div>
    </main>
    <bottomFooter />
  </div>
</template>
<style>
/* 产品中心 */
.productCenter {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding: 3.625rem 3.865% 3.5625rem;
  box-sizing: border-box;
}

.productCenter .left {
  width: 24.144%;
  margin-right: 0.793%;
}

.productCenter .navTitle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  /* height: 96px; */
  height: 6rem;
  line-height: 2.4375rem;
  font-size: 2.4375rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  background: #020e62;
  margin-bottom: 3.0625rem;
}

.productCenter .navTitle span {
  height: 2.4375rem;
}

.typeList {
  width: 100%;
  background: #fafaf9;
  padding: 0 0 0;
  margin: 0 auto;
  box-sizing: border-box;
}

.typeItem {
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 4.5rem);
  line-height: 2.5625rem;
  font-size: 1.75rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #534f4f;
  background: #ffffff;
  border: 1px solid #d1d1d1;
  padding: 1rem 0.9375rem;
  margin: 0 2.25rem 2rem;
  box-sizing: border-box;
}

.typeItem p {
  margin-bottom: 0;
}

.typeList .active {
  line-height: 2.5625rem;
  font-size: 1.75rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #020e62;
  background: #dbdffc;
  border: 1px solid #020e62;
}

.productCenter .right {
  position: relative;
  width: 75.063%;
  padding-bottom: 3rem;
}

.productList {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}

.productItem {
  position: relative;
  width: calc((100% - 9.652%) / 4);
  background: #ffffff;
  border: 2px solid #ececec;
  margin: 0 0 1.875rem 2.413%;
  box-sizing: border-box;
}

.prodIco {
  width: 100%;
  height: 20.5625rem;
  overflow: hidden;
}

.prodIco img {
  width: 100%;
  height: 100%;
}

.searchResult {
  width: 100%;
  line-height: 1.5rem;
  font-size: 1rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  text-align: left;
  color: #333;
  margin: 2rem 0;
  padding: 0 4%;
  box-sizing: border-box;
}

.modal-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
}

.modal-container {
  width: 17.5rem;
  border-radius: 0.3125rem;
  background: #fff;
}

.modal-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 3.125rem;
  line-height: 1rem;
  font-size: 1rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333;
  border-bottom: 1px solid #f2f2f2;
  padding: 0 0.625rem;
  box-sizing: border-box;
}

.modal-top .close {
  width: 0.9375rem;
  height: 0.9375rem;
}

.modal-main {
  text-align: left;
  padding: 1.25rem 2.5rem;
}

.modal-bottom {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding-right: 1.25rem;
  margin-bottom: 0.9375rem;
  box-sizing: border-box;
}

.confirmBtn {
  line-height: 0.875rem;
  font-size: 0.875rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #fff;
  background: #020e62;
  padding: 0.625rem 1.25rem;
}

.expand {
  -webkit-animation: show1 0.5s linear forwards;
  animation: show1 0.5s linear forwards;
}

@-webkit-keyframes show1 {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.1);
  }
}

@keyframes show1 {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.1);
  }
}

.prod-name {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 3.45rem;
  line-height: 1.25rem;
  font-size: 1.25rem;
  font-weight: bold;
  color: #000000;
  background: #f8f8f8;
  padding: 0 0.5rem;
  box-sizing: border-box;
}

.prod-name span {
  width: 100%;
  height: 1.25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  /* 强制不换行 */
  white-space: nowrap;
}

.prod-name2 {
  color: #ffffff;
  background: #020e62;
}

.productItem .add {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 95px;
  height: 95px;
  border-radius: 5px;
  margin: -47px 0 0 -47px;
  transition: all 0.8s;
}

.pagesBlock {
  position: absolute;
  bottom: 0;
  right: 0;
  margin-bottom: 0;
}
@media screen and (max-width: 1630px) {
  .productItem {
    width: calc((100% - 9.2%) / 4);
    margin: 0 0 1.875rem 2.3%;
  }

  .prodIco {
    height: 19rem;
  }

  .productCenter .navTitle {
    height: 5.5rem;
    line-height: 2.4rem;
    font-size: 2.4rem;
    margin-bottom: 2.5rem;
  }

  .productCenter .navTitle span {
    height: 2.4rem;
  }

  .typeList .active {
    line-height: 2.5rem;
    font-size: 1.7rem;
  }

  .typeItem {
    width: calc(100% - 3.4rem);
    line-height: 2.5rem;
    font-size: 1.7rem;
    padding: 1rem 0.9rem;
    margin: 0 1.7rem 1.5rem;
  }
}
@media screen and (max-width: 1400px) {
  .productItem {
    width: calc((100% - 8.4%) / 4);
    margin: 0 0 1.875rem 2.1%;
  }

  .prodIco {
    height: 17rem;
  }

  .prod-name {
    line-height: 1.15rem;
    font-size: 1.15rem;
  }

  .prod-name span {
    height: 1.15rem;
  }

  .productCenter .navTitle {
    height: 5rem;
    line-height: 2.2rem;
    font-size: 2.2rem;
    margin-bottom: 2rem;
  }
  
  .productCenter .navTitle span {
    height: 2.2rem;
  }

  .typeList .active {
    line-height: 2.2rem;
    font-size: 1.5rem;
  }

  .typeItem {
    width: calc(100% - 3rem);
    line-height: 2.2rem;
    font-size: 1.5rem;
    padding: 0.7rem 0.5rem;
    margin: 0 1.5rem 1.3rem;
  }
}
@media screen and (max-width: 1300px) {
  .productItem {
    width: calc((100% - 8%) / 4);
    margin: 0 0 1.875rem 2%;
  }

  .prodIco {
    height: 16rem;
  }

  .prod-name {
    line-height: 1.1rem;
    font-size: 1.1rem;
  }

  .prod-name span {
    height: 1.1rem;
  }
  
  .productCenter .navTitle {
    height: 5rem;
    line-height: 2.1rem;
    font-size: 2.1rem;
    margin-bottom: 1.6rem;
  }
  
  .productCenter .navTitle span {
    height: 2.1rem;
  }

  .typeList .active {
    line-height: 2.1rem;
    font-size: 1.4rem;
  }

  .typeItem {
    width: calc(100% - 2.4rem);
    line-height: 2.1rem;
    font-size: 1.4rem;
    padding: 0.7rem 0.5rem;
    margin: 0 1.2rem 1rem;
  }
}

@media screen and (max-width: 1200px) {
  .productCenter .navTitle {
    height: 4.5rem;
    line-height: 1.8rem;
    font-size: 1.8rem;
    margin-bottom: 1.4rem;
  }
  
  .productCenter .navTitle span {
    height: 1.8rem;
  }

  .typeItem {
    width: calc(100% - 2rem);
    line-height: 2rem;
    font-size: 1.2rem;
    padding: 0.5rem 0.3rem;
    margin: 0 1rem 0.8rem;
  }

  .typeList .active {
    line-height: 2rem;
    font-size: 1.2rem;
  }

  .productItem {
    width: calc((100% - 7.2%) / 3);
    margin: 0 0 1.875rem 2.4%;
  }

  .prodIco {
    height: 15rem;
  }

  .prod-name {
    line-height: 1.1rem;
    font-size: 1.05rem;
  }

  .prod-name span {
    height: 1.1rem;
  }
}

@media screen and (max-width: 900px) {
  .productCenter .left {
    width: 28%;
    margin-right: 1.5%;
  }

  .productCenter .right {
    width: 70.5%;
    padding-bottom: 3rem;
  }

  .productItem {
    width: calc((100% - 7.2%) / 2);
    margin: 0 0 1.875rem 3.6%;
  }

  .prodIco {
    height: 17rem;
  }

  .productCenter .navTitle {
    height: 3.5rem;
    line-height: 1.6rem;
    font-size: 1.6rem;
    margin-bottom: 1.2rem;
  }
  
  .productCenter .navTitle span {
    height: 1.6rem;
  }

  .typeItem {
    width: calc(100% - 1.6rem);
    line-height: 1.6rem;
    font-size: 1rem;
    padding: 0.5rem 0.3rem;
    margin: 0 0.8rem 0.8rem;
  }

  .typeList .active {
    line-height: 1.6rem;
    font-size: 1rem;
  }
}

@media (max-width: 700px) {
  .productCenter {
    flex-direction: column;
    padding: 3.625rem 5% 3.75rem !important;
  }

  .productCenter .left {
    display: flex;
    width: 100% !important;
    margin: 0 !important;
  }

  .productCenter .right {
    width: 100% !important;
    margin: 1.5rem 0 0 !important;
  }

  .productItem {
    width: calc((100% - 1.875rem) / 3);
    margin: 0 0 0.9375rem 0.9375rem;
  }

  .productItem:nth-of-type(3n + 1) {
    margin-left: 0;
  }

  .prodIco {
    height: 15rem;
  }

  .typeList {
    display: flex;
    flex-wrap: wrap;
  }

  .productCenter .navTitle,
  .typeItem {
    width: 49% !important;
    height: auto !important;
    margin: 0 0.5% 0.625rem !important;
  }

  .productCenter .navTitle {
    line-height: 1.2rem;
    font-size: 1.2rem;
  }
  
  .productCenter .navTitle span {
    height: 1.2rem;
  }

  .typeItem,
  .typeList .active {
    line-height: 1.2rem;
    font-size: 1rem;
  }

  .prod-name {
    height: 2.7rem;
  }
}

@media (max-width: 600px) {
  .productCenter {
    flex-direction: column;
    padding: 3.1rem 5% 3.3rem !important;
  }

  .productCenter .left {
    display: flex;
    width: 100% !important;
    margin: 0 !important;
  }

  .productCenter .right {
    width: 100% !important;
    margin: 1.5rem 0 0 !important;
  }

  .productItem {
    width: calc((100% - 0.9375rem) / 2);
    margin: 0 0 0.9375rem 0.9375rem;
  }

  .productItem:nth-of-type(3n + 1) {
    margin-left: 0.9375rem;
  }

  .productItem:nth-of-type(2n + 1) {
    margin-left: 0;
  }

  .prodIco {
    height: 15rem;
  }

  .typeList {
    display: flex;
    flex-wrap: wrap;
  }

  .productCenter .navTitle,
  .typeItem {
    width: 49% !important;
    height: auto !important;
    margin: 0 0.5% 0.625rem !important;
  }
  .prod-name {
    height: 2.7rem;
  }

  .features-detail div {
    width: 100%!important;
  }
}

@media (max-width: 499px) {
  .productCenter {
    flex-direction: column;
    padding: 2rem 2% 1rem !important;
  }

  .productCenter .left {
    display: flex;
    width: 100% !important;
    margin: 0 !important;
  }

  .productCenter .right {
    width: 100% !important;
    margin: 1rem 0 0 !important;
  }

  .productItem {
    width: calc((100% - 0.5rem) / 2);
    margin: 0 0 0.625rem 0.5rem;
  }


  .productItem:nth-of-type(3n + 1) {
    margin-left: 0.5rem;
  }

  .productItem:nth-of-type(2n + 1) {
    margin-left: 0;
  }

  .prodIco {
    height: 12rem;
  }

  .prod-name {
    line-height: 1.1rem;
    font-size: 1rem;
  }

  .prod-name span {
    height: 1.1rem;
  }

  .typeList {
    display: flex;
    flex-wrap: wrap;
  }

  .productCenter .navTitle,
  .typeItem {
    width: 98% !important;
    height: 2rem !important;
    margin: 0 0.5% 0.625rem !important;
    padding: 0.5rem !important;
    line-height: 1rem;
    font-size: 1rem;
  }

  .typeList .active {
    line-height: 1rem;
    font-size: 1rem;
  }

  .searchResult {
    width: 100%;
    line-height: 1.5rem;
    font-size: 1rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    text-align: left;
    color: #333;
    margin: 2rem 0;
  }
}
</style>
<script>
import bottomFooter from "@/components/bottomFooter.vue";
import flPagination from "@/components/Pagination.vue";
import { getBackground, getType, getProduct } from "../api/interface"; // 引入接口
export default {
  name: "productView",
  components: {
    bottomFooter,
    flPagination,
  },
  data() {
    return {
      backgroundColor: "",
      fontColor: "",
      scrollTop: 0,
      picture: null,
      showView: false,
      currentIdx: 0,
      typeList: [],
      INPUT: "",
      PULLNUM: 1, //当前页，起始值是1
      sumPages: 0, //总共几页
      DB_TYPE_ID: "",
      prodList: [],
      isCollapse: true, //是否折叠导航条
      bgimg1: require("../assets/collapse.png"),
      bgimg2: require("../assets/close1.png"),
      message: "",
      isShow4: false, //是否展示消息弹窗
    };
  },

  created() {
    this.getImg();
    this.getType();
  },

  mounted() {
    //首先，在mounted钩子window添加一个滚动滚动监听事件
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    //然后在方法中，添加这个handleScroll方法来获取滚动的位置
    handleScroll() {
      // let scrollTop =
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;
      let scrollTop = document.documentElement.scrollTop;
      console.log("scrollTop", scrollTop);
      //设置页面滚动时目录导航栏的背景颜色
      if (scrollTop > 100) {
        this.$set(this, "scrollTop", scrollTop);
        this.$set(this, "backgroundColor", "#fff");
        this.$set(this, "fontColor", "#000000!important");
      } else {
        this.$set(this, "scrollTop", scrollTop);
        this.$set(this, "backgroundColor", "rgba(0, 0, 0, 0.1)");
        this.$set(this, "fontColor", "#ffffff");
      }
    },

    // 折叠导航栏
    collapseNav() {
      const that = this;
      that.$set(that, "isCollapse", !that.isCollapse);
    },

    // 获取图片数据
    async getImg() {
      const that = this;
      await getBackground({ P_INFO: "product-center" }).then((res) => {
        console.log(res);
        if (res.state == "success") {
          that.$set(that, "picture", res.picture);
          if (that.picture != null) {
            that.$set(that, "showView", true);
          }
        }
      });
    },

    // 是否展示消息弹窗
    hideModal() {
      this.$set(this, "isShow4", false);
    },

    // 提交表单
    submit1(e) {
      e.preventDefault(); // 阻止默认提交行为
      console.log(this.INPUT);
      if (this.INPUT == "") {
        this.$set(this, "message", "请输入关键词！");
        this.$set(this, "isShow4", true);
      }
      this.getProduct();
    },

    // 获取产品分类
    async getType() {
      const that = this;
      await getType().then((res) => {
        console.log(res);
        if (res.state == "success") {
          that.$set(that, "typeList", res.type);
          that.$set(that, "DB_TYPE_ID", res.type[0].DB_TYPE_ID);
          that.getProduct();
        }
      });
    },

    // 获取产品列表
    async getProduct() {
      const that = this;
      await getProduct({
        DB_TYPE_ID: that.DB_TYPE_ID,
        INPUT: that.INPUT,
        PULLNUM: that.PULLNUM,
      }).then((res) => {
        console.log(res);
        that.$set(that, "sumPages", res.page.totalPage);
        that.$set(that, "PULLNUM", res.page.currentPage);
        let prodList = res.recruit;
        prodList.forEach((v) => {
          v[`active`] = false;
        });
        console.log("prodList", prodList);
        that.$set(that, "prodList", prodList);
      });
    },

    // 切换类型
    switchType(index, typeid) {
      this.$set(this, "currentIdx", index);
      this.$set(this, "DB_TYPE_ID", typeid);
      this.getProduct();
    },

    // 去产品详情
    openDetails(id) {
      console.log("点击的产品id是：" + id);
      this.$router.push({ path: "/productDetail", query: { id: id } });
    },

    mouseenter(id) {
      console.log(id);
      let prodList = this.prodList;
      prodList[id].active = true;
      console.log("prodList", prodList);
      this.$set(this, "prodList", prodList);
    },

    mouseleave(id) {
      console.log(id);
      let prodList = this.prodList;
      prodList[id].active = false;
      console.log("prodList", prodList);
      this.$set(this, "prodList", prodList);
    },

    // 页码变更
    handlePageChange(page) {
      const that = this;
      console.log("当前页码：" + page);
      that.$set(that, "PULLNUM", page);
      that.getProduct();
    },
  },
  //由于是在整个window中添加的事件，所以要在页面离开时摧毁掉，否则会报错
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
